
import Vue from "vue";
import { Contact, ContactAddress } from "@/models/base";
import AppAddress from "./ContactInfoAddress.vue";

export default Vue.extend({
	data() {
		return {
			activeAddressTab: 0,
		};
	},
	props: {
		contact: {
			type: Object as ()=>Contact,
			required: true
		}
	},
	computed: {
		addressTabs(): any {
			return this.contact.Addresses.map((k: ContactAddress, v: number) => {
				if (k.Label.trim()){
					return k.Label;
				}
				return this.$ct("titles.addres") + " " + (1 + v);
			});
		},
		activeAddress(): ContactAddress {
			return this.contact.Addresses[this.activeAddressTab];
		},
		mainAddressSelected():boolean {
			return this.activeAddress.IsMainAddress;
		}
	},
	methods: {
		selectPreviousTab(){
			if (this.activeAddressTab == 0) {
				this.activeAddressTab = this.contact.Addresses.length -1;
			}else{
				this.activeAddressTab--;
			}
		},
		selectNextTab(){
			if (this.activeAddressTab == this.contact.Addresses.length-1) {
				this.activeAddressTab = 0;
			}else{
				this.activeAddressTab++;
			}
		},
		onKeyDown(event:KeyboardEvent){
			if (!event.altKey) return;
			if (event.ctrlKey) return;
			if (event.shiftKey) return;
			if (event.key == "ArrowLeft") {
				event.preventDefault();
				event.stopPropagation();
				this.selectPreviousTab();
			} else if (event.key == "ArrowRight"){
				event.preventDefault();
				event.stopPropagation();
				this.selectNextTab();
			}
		}
	},
	created() {
		window.addEventListener("keydown", this.onKeyDown);
	},
	destroyed(){
		window.removeEventListener("keydown", this.onKeyDown);
	},
	components: {
		AppAddress
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
